import AsyncStorage from "@react-native-async-storage/async-storage";
import { config } from "../shared/environment";


// Storage Keys
const RETURN_WINDOW_STORAGE_KEY = `@order_settings_return_window_${config.storeId}`;
const ORDER_ID_STORAGE_KEY = `@order_settings_order_id_${config.storeId}`;

// Retrieve Order ID & Return Window values from AsyncStorage
export const getOrderSettingsFromAsyncStorage = async () => {
    const returnWindow = (await AsyncStorage.getItem(RETURN_WINDOW_STORAGE_KEY))

    const orderIdDataStr = await AsyncStorage.getItem(ORDER_ID_STORAGE_KEY);
    const orderId = orderIdDataStr ? JSON.parse(orderIdDataStr) : null;

    return {
        returnWindow: returnWindow ?? "14_DAYS",
        orderIdPrefixText: orderId?.orderIdPrefixText ?? "ZEN",
        orderIdSuffixText: orderId?.orderIdSuffixText ?? "ID",
    }
}

// Convert a stored return window value ("14_DAYS", "84_DAYS", "UNLIMITED") into a number of days.
// Returns null when returns are not time-limited.
export const getReturnWindowDays = (returnWindow?: string | null): number | null => {
    if (!returnWindow || returnWindow === "UNLIMITED") return null;
    const days = parseInt(returnWindow.replace("_DAYS", ""), 10);
    return Number.isNaN(days) ? null : days;
}

// Store UPI ID used to generate the payment QR code on the sell screen
export const UPI_ID_STORAGE_KEY = `@order_settings_upi_id_${config.storeId}`;

// UPI ID format: <handle>@<bank/psp>, e.g. "mystore@okaxis", "9876543210@ybl"
export const UPI_ID_REGEX = /^[a-zA-Z0-9._-]{2,256}@[a-zA-Z][a-zA-Z0-9]{1,63}$/;

export const getUpiIdFromAsyncStorage = async (): Promise<string> => {
    return (await AsyncStorage.getItem(UPI_ID_STORAGE_KEY)) ?? "";
}

// Round off the sell screen grand total to the nearest ₹1 (set in Order Settings, kept on this device)
export const ROUND_OFF_STORAGE_KEY = `@order_settings_round_off_${config.storeId}`;

export const getRoundOffFromAsyncStorage = async (): Promise<boolean> => {
    try {
        return (await AsyncStorage.getItem(ROUND_OFF_STORAGE_KEY)) === "true";
    } catch {
        return false;
    }
}

// Build a UPI deep link (NPCI format) that any UPI app can scan to pay the given amount
export const buildUpiPaymentUrl = ({ upiId, payeeName, amount, note }: { upiId: string, payeeName?: string, amount: number, note?: string }) => {
    const params = [
        `pa=${encodeURIComponent(upiId)}`,
        payeeName ? `pn=${encodeURIComponent(payeeName)}` : "",
        `am=${Number(amount).toFixed(2)}`,
        "cu=INR",
        note ? `tn=${encodeURIComponent(note)}` : "",
    ].filter(Boolean);
    return `upi://pay?${params.join("&")}`;
}
